var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselBookTradespeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#FEF9EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 57.5083H33.5C32.837 57.5083 32.2011 57.2449 31.7322 56.7761C31.2634 56.3073 31 55.6714 31 55.0083V40.25",
    stroke: "#EFC45D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 37.75L41.885 25.8417C42.3364 25.4596 42.9086 25.25 43.5 25.25C44.0914 25.25 44.6636 25.4596 45.115 25.8417L61 37.75",
    stroke: "#EFC45D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 57.5083V50.755C38.5 50.092 38.7634 49.4561 39.2322 48.9872C39.7011 48.5184 40.337 48.255 41 48.255H43.5",
    stroke: "#EFC45D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 40.25C45.5711 40.25 47.25 38.5711 47.25 36.5C47.25 34.4289 45.5711 32.75 43.5 32.75C41.4289 32.75 39.75 34.4289 39.75 36.5C39.75 38.5711 41.4289 40.25 43.5 40.25Z",
    stroke: "#EFC45D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 50.25V62.75",
    stroke: "#EFC45D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 50.25H52.25C51.7049 50.3429 51.1872 50.5555 50.7342 50.8725C50.2811 51.1895 49.904 51.6031 49.63 52.0833C49.5516 52.189 49.442 52.2673 49.3167 52.3072C49.1914 52.3471 49.0567 52.3465 48.9317 52.3056C48.8067 52.2647 48.6977 52.1854 48.6202 52.0791C48.5428 51.9728 48.5007 51.8449 48.5 51.7133V49C48.5 47.6739 49.0268 46.4021 49.9645 45.4645C50.9021 44.5268 52.1739 44 53.5 44H58.5V50.25Z",
    stroke: "#EFC45D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3333 42.75H63.5V51.5H59.3333C59.1123 51.5 58.9004 51.4122 58.7441 51.2559C58.5878 51.0996 58.5 50.8877 58.5 50.6667V43.5833C58.5 43.3623 58.5878 43.1504 58.7441 42.9941C58.9004 42.8378 59.1123 42.75 59.3333 42.75Z",
    stroke: "#EFC45D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselBookTradespeople);
export default __webpack_public_path__ + "static/media/CarouselBookTradespeople.f8b3f8d9.svg";
export { ForwardRef as ReactComponent };